module.exports = __webpack_public_path__ + "static/media/logo-wings.52a2fd18.svg";